import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';

import { Button } from '@eventbrite/marmalade';
import './CategoryCarouselSeeMore.scss';

interface CategoryCarouselSeeMoreProps {
    wrappingClasses?: string;
    onClick: Function;
    bucketKey?: string;
    label?: GenericLazyString | string;
    title?: GenericLazyString | string;
    dataTestId?: string;
    seeMoreUrl?: string;
}

export const CategoryCarouselSeeMore: React.FunctionComponent<
    CategoryCarouselSeeMoreProps
> = (props) => {
    const { wrappingClasses } = props;
    const classes = wrappingClasses ? wrappingClasses : '';
    const { bucketKey, label, onClick, title, seeMoreUrl } = props;
    const bucketLabel = title
        ? // eslint-disable-next-line gettext/no-variable-string
          gettext('Explore more events in ' + title.toString())
        : gettext('Explore more events');
    return (
        <section
            className={`category-carousel-see-more ${classes}`}
            data-testid={props?.dataTestId}
            id={bucketKey}
        >
            <div className="category-carousel-see-more__container">
                <div className="category-carousel-see-more__title eds-text-bl">
                    {bucketLabel}
                </div>
                {label && (
                    <div className="category-carousel-see-more__button">
                        <a href={seeMoreUrl}>
                            <Button
                                variant="secondary"
                                onClick={() => onClick()}
                                data-testid="view-more"
                            >
                                {label}
                            </Button>
                        </a>
                    </div>
                )}
            </div>
            {props.children}
        </section>
    );
};
